module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village/levelIcon//3_excellent.png?v=25f98bec";